<template>
  <Day :day="formattedDate">
    <div slot="page-content">
      <Day2024
        :title="title"
        :description="description"
        :date="formattedDate"
      />
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'
import days from './days.json'
import Moment from 'moment'
import Day2024 from "./Day2024.vue";

export default {
  name: 'ChallengeFactory',
  components: {
    Day2024,
    Day
  },
  computed: {
    day: function () {
      return this.$route.params['day']
    },
    year: function () {
      return this.$route.params['year']
    },
    title: function () {
      return days[this.year].title[this.day]
    },
    description: function () {
      return days[this.year].description[this.day]
    },
    formattedDate: function () {
      let date = new Moment(this.day + '.12.' + this.year, 'DD.MM.YYYY')
      return date.format('DD.MM.YYYY')
    }
  }
}
</script>
